export default "__VITE_ASSET__BQtFgA0z__"